export default {
  "b2b.provozni-informace.page-heading.new": "New operational information",
  "b2b.provozni-informace.page-heading.edit": "Edit operational information"
};
